export type SectionTitleKey = 'i18n.lists.managedByUsf';

const sectionTitleFormatters: {
  [key in SectionTitleKey]: (title: string) => string;
} = {
  'i18n.lists.managedByUsf': (title: string) => {
    return title.replace(/^(Managed By|Gestionado por)(\s+)/, '$1<br>');
  },
};

export function formatSectionTitle(
  key: SectionTitleKey,
  title: string,
): string {
  const formatter = sectionTitleFormatters[key];
  return formatter ? formatter(title) : title;
}
